module.exports = __webpack_public_path__ + "static/img/IMG-20150730-WA0000.95bf6311.jpg";